import {
  fa1,
  faPlus,
  faUser,
  faUsers,
  faArrowsSpin,
  faCalendarRange,
  faCalendarPlus,
} from '@fortawesome/pro-light-svg-icons';

// ---------------- questionId: 10001

export const getOptionDetails10001 = (option: string, index: number) => {
  switch (option) {
    case 'This is the first year':
      return {
        icon: fa1,
      };

    default:
      return {
        icon: faPlus,
      };
  }
};

// ---------------- questionId: 10002

const continuousTypes = ['Food banks', 'Homeless shelters', 'Museums'];
const scheduledTypes = [
  'Summer camps',
  'Park cleanups',
  'Job trainings or apprenticeships',
];

export const getOptionDetails10002 = (option: string, index: number) => {
  switch (option) {
    case 'Continuously, with no scheduled start or end date':
      return {
        heading: 'Example programs:',
        subHeading: continuousTypes,
        icon: faArrowsSpin,
      };

    default:
      return {
        heading: 'Example programs:',
        subHeading: scheduledTypes,
        icon: faCalendarRange,
      };
  }
};

// ---------------- questionId: 10004

const lessThanYearTypes = [
  'Summer camps',
  'Park cleanups',
  'Disaster responses',
];
const moreThanYearTypes = [
  'Multi-year apprenticeships',
  'Infrastructure developments (For example: Building a new water sanitation system + 1 year of impacts)',
];

export const getOptionDetails10004 = (option: string, index: number) => {
  switch (option) {
    case 'Takes a year or less to complete':
      return {
        heading: 'Example programs:',
        subHeading: lessThanYearTypes,
        icon: faCalendarRange,
      };

    default:
      return {
        heading: 'Example programs:',
        subHeading: moreThanYearTypes,
        icon: faCalendarPlus,
      };
  }
};

// ---------------- questionId: 10005

export const getOptionDetails10005 = (option: string, index: number) => {
  switch (option) {
    case 'Once':
      return {
        icon: fa1,
      };

    default:
      return {
        icon: faCalendarRange,
      };
  }
};

// ---------------- questionId: 10007

export const getOptionDetails10007 = (option: string, index: number) => {
  switch (option) {
    case 'One single report for all implementations':
      return {
        icon: faUser,
      };

    default:
      return {
        icon: faUsers,
      };
  }
};
